module.exports = __webpack_public_path__ + "static/img/akum_230.9674d26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akum_230.svg
// module id = qj+J
// module chunks = 1